import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Conf } from 'src/app/conf';
import { AppService } from 'src/app/services/app.service';



@Component({
  selector: 'app-sign-out-page',
  templateUrl: './sign-out-page.component.html',
  styleUrls: ['./sign-out-page.component.scss']
})
export class SignOutPageComponent {

  private clientId: string;

  constructor(private app: AppService, private route: ActivatedRoute) {
    this.clientId = this.route.snapshot.paramMap.get('clientId');

    this.app.isAuthed((auth: boolean) => {

      if (auth) {
        this.app.logout().then((status) => {

          this.redirect2Client();
        });
      } else {
        this.redirect2Client();
      }
    });


  }

  public redirect2Client(): void {
    if (this.clientId && Conf.bootstrap[this.clientId].redirectUrl && Conf.bootstrap[this.clientId].redirectUrl.logout ||
      this.app.context !== 'sso' && Conf.bootstrap[this.app.context].redirectUrl && Conf.bootstrap[this.app.context].redirectUrl.logout) {
      window.location.href = Conf.bootstrap[this.clientId].redirectUrl.logout;
    }
  }


}
